import { forwardRef } from 'react';

import { URLQueryParamNames } from '@src/types/urlQueryParamNames';

import Checkbox from '@helsenorge/designsystem-react/components/Checkbox';

interface Props {
  filters: Record<string, boolean>;
  malgruppe: { displayname: string; value: string };
  malgrupperValgt: string[];
  setMalgrupperValgt: (arr: string[]) => void;
  setDelayedFilter: (key: string, val: string) => void;
}

const MalgruppeDropdown = forwardRef<HTMLInputElement, Props>(
  ({ filters, malgruppe, malgrupperValgt, setMalgrupperValgt, setDelayedFilter }, ref) => {
    const keyBase = `${URLQueryParamNames.Malgruppe.toLowerCase()}-${malgruppe.displayname}`;

    return (
      <Checkbox
        key={keyBase}
        label={malgruppe.displayname}
        value={malgruppe.displayname}
        inputId={`${keyBase}-${malgruppe.value}`}
        checked={filters && !!filters[keyBase]}
        ref={ref}
        onChange={e => {
          setMalgrupperValgt(
            e.target.checked
              ? [...malgrupperValgt, malgruppe.value].filter((v, i, a) => a.indexOf(v) === i)
              : malgrupperValgt.filter(v => v !== malgruppe.value)
          );
          setDelayedFilter(keyBase, e.target.checked ? e.target.value : '');
        }}
      />
    );
  }
);

// Set a readable display name for React DevTools
MalgruppeDropdown.displayName = 'MalgruppeDropdown';

export default MalgruppeDropdown;
